import { MobileIcon, PCIcon, ConsoleIcon } from "../shared/PlatformIcons";

import type { PlatformType } from "~/helpers/prepare-tournament-data";
export type { PlatformType } from "~/helpers/prepare-tournament-data";

const TournamentMeta: React.FC<{
  platform: PlatformType;
  tournamentType: string;
  intendedParticipants: string | number;
  teamType: string;
  totalPot?: string;
}> = ({ platform, tournamentType, intendedParticipants, teamType, totalPot }) => {
  const classNames = `flex flex-col mt-auto mb-2
    justify-center items-center
    uppercase font-bold 
    text-[10px] text-center`;
  return (
    <div className="flex flex-row items-center justify-center gap-x-4 mt-4 mb-8 lg:mb-0 text-jiwe-dark-blue dark:text-grey-light">
      {/* Icons */}
      <div className={classNames}>
        {platform === "console" && <ConsoleIcon />}
        {platform === "mobile" && <MobileIcon />}
        {platform === "pc" && <PCIcon />}
        {platform === "cross-platform" && (
          <div className="flex gap-y-1 justify-center items-center">
            <MobileIcon />
            <PCIcon />
            <ConsoleIcon />
          </div>
        )}
        {platform === "unknown" ? "Platform unknown" : platform.toUpperCase()}
      </div>
      {/* Tournament Type */}
      <span className="uppercase font-bold text-[10px] text-center max-w-[4.5rem]">
        {tournamentType}
      </span>
      {/* No. Teams */}
      <span className="uppercase font-bold text-[10px] text-center max-w-[3rem]">
        <b className="text-3xl block leading-[0.6] font-bold">
          {intendedParticipants}
        </b>
        {teamType}
      </span>
      {/* Pot */}
      {totalPot && (
        <span className="uppercase font-bold text-[10px] text-center max-w-[3rem]">
          KES
          <b className="text-3xl block leading-[0.6] font-bold">{totalPot}</b>
          pot
        </span>
      )}
    </div>
  );
};

export default TournamentMeta;
